// Local translations
export const T = {
  en_GB: {
    title: "Risk bounds",
    enable: "Enforce risk bounds",
    enableHint:
      "When enabled, each goal's year-1 equity share and volatility are checked against the ceiling for the goal's risk score by the Equity Share Chart and Volatility Chart components, across every portfolio type. A breach blocks the flow from being completed until the advisor decides. Flows using this model must place those charts and a Risk Assessment, on a portfolio collection with 'Requires asset allocation' on.",
    deviationAcceptance: "Allow deviation acceptance",
    deviationAcceptanceHint:
      "When enabled, the advisor may accept a breach with a mandatory justification instead of being hard-blocked.",
    deviationAcceptanceLocked: "Turn on Enforce risk bounds to change this.",
    score: "Risk score",
    maxEquity: "Max equity share (%)",
    maxVolatility: "Max volatility (%)",
    boundsHint:
      'One ceiling pair per risk score. Values are 0.0–100.0 with 1 decimal and must not decrease from one score to the next (equal values are allowed); leave a value empty for "no cap" (only allowed above a capped score).',
    noMatrix: "Fill in the score matrix before configuring risk bounds.",
    save: "Save",
    saved: "Saved",
    error: "Error",
    failedToSave: "Failed to save risk bounds",
  },
  nb_NO: {
    title: "Risikogrenser",
    enable: "Håndhev risikogrenser",
    enableHint:
      "Når aktivert sjekkes hvert måls aksjeandel og volatilitet i år 1 mot grensen for målets risikoscore av komponentene Aksjeandelsgraf og Volatilitetsgraf, for alle porteføljetyper. Et brudd blokkerer fullføring av flyten til rådgiveren har tatt en beslutning. Flyter som bruker denne modellen må plassere disse grafene og en risikovurdering, på en porteføljesamling med «Krever aktivaallokering» på.",
    deviationAcceptance: "Tillat aksept av avvik",
    deviationAcceptanceHint:
      "Når aktivert kan rådgiveren akseptere et brudd med en obligatorisk begrunnelse i stedet for å bli blokkert.",
    deviationAcceptanceLocked: "Slå på Håndhev risikogrenser for å endre dette.",
    score: "Risikoscore",
    maxEquity: "Maks aksjeandel (%)",
    maxVolatility: "Maks volatilitet (%)",
    boundsHint:
      "Ett grensepar per risikoscore. Verdier er 0,0–100,0 med 1 desimal og kan ikke synke fra én score til den neste (like verdier er tillatt); la en verdi stå tom for «ingen grense» (kun tillatt over en begrenset score).",
    noMatrix: "Fyll inn scorematrisen før du konfigurerer risikogrenser.",
    save: "Lagre",
    saved: "Lagret",
    error: "Feil",
    failedToSave: "Kunne ikke lagre risikogrenser",
  },
} as const;
